import React, { useState, useEffect } from 'react';
import axios from "../utils/axiosInstance";

const UmuntuMuRugo = () => {
  const [formData, setFormData] = useState({
    umuntu_id: '',
    urugo_id: '',
    umwanya_mu_rugo: 'Umwana',
    umwuga_akazi: '',
    afite_umushinga: false,
    afite_akazi_gahoraho: false,
    urwego_amashuri: 'Ntacyo',
    abana_bari_ku_ishuri: '',
    abana_batari_ku_ishuri: '',
    yatangiye_umwanya: '',
    yararaye_umwanya: ''
  });

  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeView, setActiveView] = useState('form');
  const [expandedCard, setExpandedCard] = useState(null);

  useEffect(() => {
    fetchLinks();
  }, []);

  useEffect(() => {
    if (success) {
      const t = setTimeout(() => setSuccess(null), 5000);
      return () => clearTimeout(t);
    }
  }, [success]);

  useEffect(() => {
    if (error) {
      const t = setTimeout(() => setError(null), 6000);
      return () => clearTimeout(t);
    }
  }, [error]);

  const fetchLinks = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await axios.get('/umuntu_mu_rugo', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRecords(res.data || []);
    } catch (err) {
      setError(typeof err.response?.data?.error === 'string' ? err.response.data.error : 'Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const initialForm = {
    umuntu_id: '', urugo_id: '', umwanya_mu_rugo: 'Umwana',
    umwuga_akazi: '', afite_umushinga: false, afite_akazi_gahoraho: false,
    urwego_amashuri: 'Ntacyo', abana_bari_ku_ishuri: '',
    abana_batari_ku_ishuri: '', yatangiye_umwanya: '', yararaye_umwanya: ''
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setSubmitting(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post('/umuntu_mu_rugo', formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSuccess(res.data.message || 'Umuntu yongewe mu rugo neza!');
      fetchLinks();
      setFormData(initialForm);
    } catch (err) {
      setError(typeof err.response?.data?.error === 'string' ? err.response.data.error : 'Failed to save');
    } finally {
      setSubmitting(false);
    }
  };

  const filteredRecords = records.filter(r =>
    (r.umuntu_name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (r.nimero_urugo || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (r.amazina_umukuru || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (r.nimero_nida || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getRoleBadge = (role) => {
    const colors = {
      'Umukuru_w_urugo': { bg: 'rgba(168,85,247,0.15)', color: '#c084fc', border: 'rgba(168,85,247,0.25)' },
      'Umugore': { bg: 'rgba(244,63,94,0.12)', color: '#fb7185', border: 'rgba(244,63,94,0.2)' },
      'Umugabo': { bg: 'rgba(59,130,246,0.12)', color: '#60a5fa', border: 'rgba(59,130,246,0.2)' },
      'Umwana': { bg: 'rgba(34,197,94,0.12)', color: '#4ade80', border: 'rgba(34,197,94,0.2)' },
      'Umukurambere': { bg: 'rgba(245,158,11,0.12)', color: '#fbbf24', border: 'rgba(245,158,11,0.2)' },
      'Umuvandimwe': { bg: 'rgba(6,182,212,0.12)', color: '#22d3ee', border: 'rgba(6,182,212,0.2)' },
    };
    const c = colors[role] || { bg: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.6)', border: 'rgba(255,255,255,0.1)' };
    return c;
  };

  const getEduBadge = (level) => {
    const map = {
      'Kaminuza': { bg: 'rgba(99,102,241,0.15)', color: '#818cf8' },
      'Ayisumbuye': { bg: 'rgba(6,182,212,0.12)', color: '#22d3ee' },
      'Abanza': { bg: 'rgba(34,197,94,0.12)', color: '#4ade80' },
      'TvET': { bg: 'rgba(245,158,11,0.12)', color: '#fbbf24' },
      'Ntacyo': { bg: 'rgba(255,255,255,0.05)', color: 'rgba(255,255,255,0.35)' },
    };
    return map[level] || map['Ntacyo'];
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;500;600;700;800;900&display=swap');

        *, *::before, *::after {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        .umr-root {
          font-family: 'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          -webkit-tap-highlight-color: transparent;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        ::-webkit-scrollbar { width: 5px; height: 5px; }
        ::-webkit-scrollbar-track { background: rgba(255,255,255,0.01); }
        ::-webkit-scrollbar-thumb { background: rgba(139,92,246,0.25); border-radius: 10px; }
        ::-webkit-scrollbar-thumb:hover { background: rgba(139,92,246,0.45); }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(28px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes scaleIn {
          from { opacity: 0; transform: scale(0.93); }
          to { opacity: 1; transform: scale(1); }
        }
        @keyframes slideRow {
          from { opacity: 0; transform: translateX(-18px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes popIn {
          0% { opacity: 0; transform: translateY(-16px) scale(0.92); }
          60% { transform: translateY(3px) scale(1.01); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes gradientWave {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        @keyframes shimmer {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        @keyframes breathe {
          0%, 100% { box-shadow: 0 0 0 0 rgba(139,92,246,0); }
          50% { box-shadow: 0 0 0 8px rgba(139,92,246,0.06); }
        }
        @keyframes dotBounce {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1); }
        }
        @keyframes floatIcon {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-6px) rotate(-3deg); }
        }

        .umr-app {
          min-height: 100vh;
          min-height: 100dvh;
          background: #000000;
          color: #ffffff;
          position: relative;
          overflow-x: hidden;
        }
        .umr-app::before {
          content: '';
          position: fixed;
          inset: 0;
          background:
            radial-gradient(ellipse 80% 60% at 15% 10%, rgba(139,92,246,0.07) 0%, transparent 60%),
            radial-gradient(ellipse 60% 80% at 85% 85%, rgba(59,130,246,0.05) 0%, transparent 55%),
            radial-gradient(ellipse 50% 50% at 50% 50%, rgba(168,85,247,0.03) 0%, transparent 50%);
          pointer-events: none;
          z-index: 0;
        }

        .umr-content {
          position: relative;
          z-index: 1;
          max-width: 1380px;
          margin: 0 auto;
          padding: 24px 16px 40px;
        }

        /* ── Header ── */
        .umr-header {
          text-align: center;
          margin-bottom: 36px;
          animation: fadeUp 0.55s ease;
        }
        .umr-badge {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          padding: 5px 14px;
          border-radius: 10px;
          background: rgba(139,92,246,0.1);
          border: 1px solid rgba(139,92,246,0.18);
          color: #a78bfa;
          font-size: 0.7rem;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          margin-bottom: 14px;
        }
        .umr-title {
          font-size: clamp(1.4rem, 5vw, 2.6rem);
          font-weight: 900;
          line-height: 1.1;
          margin-bottom: 8px;
          background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 30%, #a855f7 60%, #8b5cf6 100%);
          background-size: 300% 300%;
          animation: gradientWave 7s ease infinite;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .umr-subtitle {
          color: rgba(255,255,255,0.3);
          font-size: clamp(0.85rem, 2vw, 1rem);
          font-weight: 400;
          max-width: 460px;
          margin: 0 auto;
        }

        /* ── Stats ── */
        .umr-stats {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 14px;
          margin-bottom: 36px;
          animation: fadeUp 0.65s ease;
        }
        .umr-stat {
          background: linear-gradient(145deg, rgba(16,16,28,0.9), rgba(10,10,20,0.95));
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border: 1px solid rgba(255,255,255,0.05);
          border-radius: 18px;
          padding: 22px 14px;
          text-align: center;
          transition: all 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          position: relative;
          overflow: hidden;
        }
        .umr-stat::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          border-radius: 18px 18px 0 0;
          opacity: 0;
          transition: opacity 0.35s ease;
        }
        .umr-stat:hover { transform: translateY(-6px); border-color: rgba(255,255,255,0.09); }
        .umr-stat:hover::after { opacity: 1; }
        .umr-stat.violet::after { background: linear-gradient(90deg, #8b5cf6, #a855f7); }
        .umr-stat.violet:hover { box-shadow: 0 16px 48px rgba(139,92,246,0.12); }
        .umr-stat.blue::after { background: linear-gradient(90deg, #3b82f6, #6366f1); }
        .umr-stat.blue:hover { box-shadow: 0 16px 48px rgba(59,130,246,0.12); }
        .umr-stat.emerald::after { background: linear-gradient(90deg, #10b981, #34d399); }
        .umr-stat.emerald:hover { box-shadow: 0 16px 48px rgba(16,185,129,0.12); }
        .umr-stat.amber::after { background: linear-gradient(90deg, #f59e0b, #fbbf24); }
        .umr-stat.amber:hover { box-shadow: 0 16px 48px rgba(245,158,11,0.12); }
        .umr-stat-icon {
          width: 46px;
          height: 46px;
          border-radius: 14px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          margin-bottom: 12px;
          transition: transform 0.35s ease;
        }
        .umr-stat:hover .umr-stat-icon { transform: scale(1.12) rotate(-5deg); }
        .umr-stat-val {
          font-size: clamp(1.4rem, 3vw, 2rem);
          font-weight: 800;
          color: #fff;
          line-height: 1;
          margin-bottom: 4px;
          letter-spacing: -0.03em;
        }
        .umr-stat-lbl {
          font-size: 0.65rem;
          color: rgba(255,255,255,0.35);
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
        }

        /* ── Toggle ── */
        .umr-toggle-wrap {
          display: flex;
          justify-content: center;
          margin-bottom: 32px;
          animation: fadeUp 0.75s ease;
        }
        .umr-toggle {
          display: flex;
          gap: 3px;
          padding: 4px;
          border-radius: 14px;
          background: rgba(14,14,24,0.85);
          border: 1px solid rgba(255,255,255,0.06);
        }
        .umr-toggle-btn {
          padding: 11px 24px;
          border: none;
          border-radius: 11px;
          font-weight: 600;
          font-size: 0.85rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 7px;
          transition: all 0.3s ease;
          white-space: nowrap;
          font-family: inherit;
        }
        .umr-toggle-btn.active {
          background: linear-gradient(135deg, #8b5cf6, #6366f1);
          color: #fff;
          box-shadow: 0 4px 18px rgba(139,92,246,0.35);
        }
        .umr-toggle-btn:not(.active) {
          background: transparent;
          color: rgba(255,255,255,0.45);
        }
        .umr-toggle-btn:not(.active):hover {
          color: rgba(255,255,255,0.75);
          background: rgba(255,255,255,0.04);
        }
        .umr-toggle-count {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 26px;
          height: 24px;
          padding: 0 7px;
          border-radius: 7px;
          background: rgba(139,92,246,0.18);
          color: #a78bfa;
          font-size: 0.73rem;
          font-weight: 700;
        }

        /* ── Glass Panel ── */
        .umr-glass {
          background: linear-gradient(140deg, rgba(14,14,26,0.88), rgba(8,8,16,0.96));
          backdrop-filter: blur(24px) saturate(1.2);
          -webkit-backdrop-filter: blur(24px) saturate(1.2);
          border: 1px solid rgba(255,255,255,0.055);
          border-radius: 22px;
          transition: border-color 0.4s ease, box-shadow 0.4s ease;
          overflow: hidden;
        }
        .umr-glass:hover {
          border-color: rgba(139,92,246,0.12);
          box-shadow: 0 6px 32px rgba(0,0,0,0.25), 0 0 60px rgba(139,92,246,0.04);
        }
        .umr-glass-body {
          padding: clamp(20px, 4vw, 44px);
        }

        /* ── Form Header ── */
        .umr-form-head {
          display: flex;
          align-items: center;
          gap: 14px;
          margin-bottom: 28px;
          padding-bottom: 24px;
          border-bottom: 1px solid rgba(255,255,255,0.045);
        }
        .umr-form-icon {
          width: 52px;
          height: 52px;
          border-radius: 15px;
          background: linear-gradient(135deg, #8b5cf6, #6366f1);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.3rem;
          color: #fff;
          flex-shrink: 0;
          box-shadow: 0 4px 18px rgba(139,92,246,0.3);
          animation: breathe 3s ease-in-out infinite;
        }
        .umr-form-title {
          font-size: clamp(1.1rem, 2.5vw, 1.3rem);
          font-weight: 800;
          color: #fff;
          margin-bottom: 3px;
        }
        .umr-form-desc {
          font-size: 0.82rem;
          color: rgba(255,255,255,0.3);
        }

        /* ── Section Divider ── */
        .umr-section {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 20px;
          padding-bottom: 14px;
          border-bottom: 1px solid rgba(255,255,255,0.04);
        }
        .umr-section-dot {
          width: 34px;
          height: 34px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.85rem;
          flex-shrink: 0;
        }
        .umr-section-text {
          font-size: 0.76rem;
          font-weight: 700;
          color: rgba(255,255,255,0.6);
          text-transform: uppercase;
          letter-spacing: 0.08em;
        }

        /* ── Form Grid ── */
        .umr-grid {
          display: grid;
          gap: 16px;
        }
        .umr-grid-2 { grid-template-columns: repeat(2, 1fr); }
        .umr-grid-3 { grid-template-columns: repeat(3, 1fr); }
        .umr-grid-full { grid-template-columns: 1fr; }

        /* ── Inputs ── */
        .umr-field { position: relative; }
        .umr-label {
          display: block;
          font-size: 0.73rem;
          font-weight: 650;
          color: rgba(255,255,255,0.45);
          margin-bottom: 7px;
          text-transform: uppercase;
          letter-spacing: 0.06em;
          transition: color 0.3s ease;
        }
        .umr-field:focus-within .umr-label { color: #a78bfa; }
        .umr-required { color: #f87171; margin-left: 2px; }

        .umr-input-wrap {
          position: relative;
        }
        .umr-input-icon {
          position: absolute;
          left: 14px;
          top: 50%;
          transform: translateY(-50%);
          color: rgba(255,255,255,0.2);
          font-size: 0.95rem;
          transition: color 0.3s ease;
          z-index: 2;
          pointer-events: none;
        }
        .umr-field:focus-within .umr-input-icon { color: #8b5cf6; }

        .umr-input {
          width: 100%;
          padding: 13px 14px 13px 42px;
          background: rgba(14,14,28,0.6);
          border: 1.5px solid rgba(255,255,255,0.065);
          border-radius: 13px;
          color: #fff;
          font-size: 0.92rem;
          font-weight: 500;
          font-family: inherit;
          outline: none;
          transition: all 0.3s ease;
          -webkit-appearance: none;
          appearance: none;
        }
        .umr-input.no-icon { padding-left: 14px; }
        .umr-input::placeholder { color: rgba(255,255,255,0.18); }
        .umr-input:hover:not(:focus) {
          border-color: rgba(255,255,255,0.1);
          background: rgba(16,16,32,0.7);
        }
        .umr-input:focus {
          border-color: #8b5cf6;
          background: rgba(18,18,36,0.85);
          box-shadow: 0 0 0 4px rgba(139,92,246,0.1), 0 4px 16px rgba(139,92,246,0.06);
        }

        .umr-select {
          width: 100%;
          padding: 13px 38px 13px 42px;
          background: rgba(14,14,28,0.6);
          border: 1.5px solid rgba(255,255,255,0.065);
          border-radius: 13px;
          color: #fff;
          font-size: 0.92rem;
          font-weight: 500;
          font-family: inherit;
          outline: none;
          transition: all 0.3s ease;
          cursor: pointer;
          -webkit-appearance: none;
          appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='rgba(255,255,255,0.35)' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 14px center;
        }
        .umr-select:focus {
          border-color: #8b5cf6;
          box-shadow: 0 0 0 4px rgba(139,92,246,0.1), 0 4px 16px rgba(139,92,246,0.06);
          background-color: rgba(18,18,36,0.85);
        }
        .umr-select option { background: #0e0e1c; color: #fff; }

        .umr-textarea {
          width: 100%;
          padding: 13px 14px;
          background: rgba(14,14,28,0.6);
          border: 1.5px solid rgba(255,255,255,0.065);
          border-radius: 13px;
          color: #fff;
          font-size: 0.92rem;
          font-weight: 500;
          font-family: inherit;
          outline: none;
          transition: all 0.3s ease;
          resize: vertical;
          min-height: 90px;
          line-height: 1.6;
          -webkit-appearance: none;
        }
        .umr-textarea::placeholder { color: rgba(255,255,255,0.18); }
        .umr-textarea:focus {
          border-color: #8b5cf6;
          box-shadow: 0 0 0 4px rgba(139,92,246,0.1), 0 4px 16px rgba(139,92,246,0.06);
          background: rgba(18,18,36,0.85);
        }

        /* ── Checkbox ── */
        .umr-check {
          display: flex;
          align-items: center;
          gap: 11px;
          padding: 14px 16px;
          background: rgba(14,14,28,0.45);
          border: 1.5px solid rgba(255,255,255,0.05);
          border-radius: 13px;
          cursor: pointer;
          transition: all 0.3s ease;
          user-select: none;
          -webkit-user-select: none;
        }
        .umr-check:hover {
          border-color: rgba(139,92,246,0.18);
          background: rgba(18,18,36,0.5);
        }
        .umr-check input { position: absolute; opacity: 0; width: 0; height: 0; }
        .umr-check-box {
          width: 22px;
          height: 22px;
          min-width: 22px;
          border-radius: 7px;
          border: 2px solid rgba(255,255,255,0.14);
          background: rgba(14,14,28,0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.25s ease;
          font-size: 0.65rem;
          color: transparent;
        }
        .umr-check input:checked + .umr-check-box {
          background: linear-gradient(135deg, #8b5cf6, #6366f1);
          border-color: #8b5cf6;
          box-shadow: 0 2px 10px rgba(139,92,246,0.35);
          color: #fff;
        }
        .umr-check-text {
          font-size: 0.84rem;
          color: rgba(255,255,255,0.55);
          font-weight: 500;
          line-height: 1.3;
          transition: color 0.3s ease;
        }
        .umr-check:has(input:checked) .umr-check-text { color: rgba(255,255,255,0.9); }
        .umr-check:has(input:checked) { border-color: rgba(139,92,246,0.2); background: rgba(139,92,246,0.04); }

        /* ── Buttons ── */
        .umr-btn-row {
          display: flex;
          gap: 12px;
          padding-top: 20px;
          border-top: 1px solid rgba(255,255,255,0.04);
          margin-top: 8px;
        }
        .umr-btn-primary {
          position: relative;
          padding: 15px 36px;
          background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 50%, #8b5cf6 100%);
          background-size: 200% auto;
          color: #fff;
          border: none;
          border-radius: 14px;
          font-weight: 700;
          font-size: 0.95rem;
          font-family: inherit;
          cursor: pointer;
          transition: all 0.4s ease;
          overflow: hidden;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 9px;
          min-height: 54px;
        }
        .umr-btn-primary::before {
          content: '';
          position: absolute;
          inset: 0;
          background: rgba(255,255,255,0);
          border-radius: 14px;
          transition: background 0.4s ease;
        }
        .umr-btn-primary:hover::before { background: rgba(255,255,255,0.08); }
        .umr-btn-primary:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 36px rgba(139,92,246,0.4), 0 4px 12px rgba(139,92,246,0.25);
          background-position: right center;
        }
        .umr-btn-primary:active { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(139,92,246,0.25); }
        .umr-btn-primary:disabled { opacity: 0.55; cursor: not-allowed; transform: none; box-shadow: none; }
        .umr-btn-primary > span { position: relative; z-index: 1; display: flex; align-items: center; gap: 9px; }

        .umr-btn-ghost {
          padding: 15px 36px;
          background: transparent;
          color: rgba(255,255,255,0.5);
          border: 1.5px solid rgba(255,255,255,0.08);
          border-radius: 14px;
          font-weight: 600;
          font-size: 0.95rem;
          font-family: inherit;
          cursor: pointer;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 9px;
          min-height: 54px;
        }
        .umr-btn-ghost:hover {
          color: #fff;
          border-color: rgba(255,255,255,0.2);
          background: rgba(255,255,255,0.03);
          transform: translateY(-2px);
        }

        /* ── Alerts ── */
        .umr-alert {
          padding: 14px 18px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 500;
          font-size: 0.88rem;
          margin-bottom: 20px;
          animation: popIn 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);
          border: 1px solid;
        }
        .umr-alert-ok {
          background: rgba(34,197,94,0.07);
          border-color: rgba(34,197,94,0.18);
          color: #4ade80;
        }
        .umr-alert-err {
          background: rgba(239,68,68,0.07);
          border-color: rgba(239,68,68,0.18);
          color: #f87171;
        }
        .umr-alert-icon {
          width: 36px;
          height: 36px;
          min-width: 36px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1rem;
        }
        .umr-alert-close {
          margin-left: auto;
          background: none;
          border: none;
          color: inherit;
          cursor: pointer;
          padding: 4px;
          opacity: 0.6;
          font-size: 1rem;
          font-family: inherit;
          transition: opacity 0.2s;
        }
        .umr-alert-close:hover { opacity: 1; }

        /* ── Search ── */
        .umr-search-wrap {
          position: relative;
          max-width: 400px;
          width: 100%;
        }
        .umr-search-icon {
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
          color: rgba(255,255,255,0.2);
          font-size: 1rem;
          transition: color 0.3s ease;
          z-index: 2;
        }
        .umr-search-wrap:focus-within .umr-search-icon { color: #8b5cf6; }
        .umr-search {
          width: 100%;
          padding: 13px 18px 13px 46px;
          background: rgba(14,14,28,0.6);
          border: 1.5px solid rgba(255,255,255,0.06);
          border-radius: 14px;
          color: #fff;
          font-size: 0.88rem;
          font-weight: 500;
          font-family: inherit;
          outline: none;
          transition: all 0.3s ease;
        }
        .umr-search::placeholder { color: rgba(255,255,255,0.22); }
        .umr-search:focus {
          border-color: #8b5cf6;
          box-shadow: 0 0 0 4px rgba(139,92,246,0.08);
          background: rgba(18,18,36,0.85);
        }

        /* ── Table ── */
        .umr-table-wrap {
          border-radius: 14px;
          overflow: hidden;
          border: 1px solid rgba(255,255,255,0.04);
        }
        .umr-table-scroll {
          max-height: 520px;
          overflow-y: auto;
        }
        .umr-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0;
        }
        .umr-table thead { position: sticky; top: 0; z-index: 5; }
        .umr-table th {
          padding: 14px 18px;
          font-size: 0.68rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.1em;
          color: rgba(255,255,255,0.35);
          border-bottom: 1px solid rgba(255,255,255,0.05);
          background: rgba(10,10,18,0.96);
          backdrop-filter: blur(8px);
          white-space: nowrap;
          text-align: left;
        }
        .umr-table td {
          padding: 14px 18px;
          font-size: 0.86rem;
          color: rgba(255,255,255,0.7);
          border-bottom: 1px solid rgba(255,255,255,0.025);
          vertical-align: middle;
        }
        .umr-table tbody tr { transition: all 0.25s ease; cursor: default; }
        .umr-table tbody tr:hover { background: rgba(139,92,246,0.05); }
        .umr-table tbody tr:last-child td { border-bottom: none; }

        .umr-tag {
          display: inline-flex;
          align-items: center;
          padding: 3px 10px;
          border-radius: 7px;
          font-size: 0.72rem;
          font-weight: 650;
          letter-spacing: 0.02em;
          border: 1px solid;
          white-space: nowrap;
        }

        /* ── Mobile Cards ── */
        .umr-mobile-card {
          display: none;
          background: rgba(14,14,28,0.6);
          border: 1px solid rgba(255,255,255,0.05);
          border-radius: 16px;
          padding: 18px;
          margin-bottom: 10px;
          transition: all 0.3s ease;
        }
        .umr-mobile-card:active {
          background: rgba(139,92,246,0.05);
          border-color: rgba(139,92,246,0.12);
        }
        .umr-mc-head {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 12px;
        }
        .umr-mc-name {
          font-weight: 700;
          color: #fff;
          font-size: 0.95rem;
          margin-bottom: 5px;
        }
        .umr-mc-row {
          display: flex;
          justify-content: space-between;
          padding: 7px 0;
          border-bottom: 1px solid rgba(255,255,255,0.025);
          font-size: 0.82rem;
        }
        .umr-mc-row:last-child { border-bottom: none; }
        .umr-mc-lbl { color: rgba(255,255,255,0.35); font-weight: 500; }
        .umr-mc-val { color: rgba(255,255,255,0.8); font-weight: 600; text-align: right; }

        /* ── Empty / Loader ── */
        .umr-empty {
          text-align: center;
          padding: 56px 20px;
        }
        .umr-empty-icon {
          width: 72px;
          height: 72px;
          border-radius: 22px;
          background: rgba(139,92,246,0.06);
          border: 1px solid rgba(139,92,246,0.1);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 1.8rem;
          color: rgba(139,92,246,0.35);
          margin-bottom: 18px;
          animation: floatIcon 3s ease-in-out infinite;
        }
        .umr-loader {
          display: flex;
          gap: 6px;
          justify-content: center;
          align-items: center;
          padding: 56px;
        }
        .umr-loader span {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #8b5cf6;
          animation: dotBounce 1.4s infinite ease-in-out both;
        }
        .umr-loader span:nth-child(1) { animation-delay: -0.32s; }
        .umr-loader span:nth-child(2) { animation-delay: -0.16s; }

        /* ── Responsive ── */
        @media (max-width: 991px) {
          .umr-stats { grid-template-columns: repeat(2, 1fr); }
          .umr-grid-3 { grid-template-columns: repeat(2, 1fr); }
        }

        @media (max-width: 767px) {
          .umr-content { padding: 16px 12px 32px; }
          .umr-desktop-table { display: none !important; }
          .umr-mobile-card { display: block !important; }
          .umr-toggle { width: 100%; }
          .umr-toggle-btn { flex: 1; justify-content: center; font-size: 0.8rem; padding: 11px 14px; }
          .umr-grid-2, .umr-grid-3 { grid-template-columns: 1fr; }
          .umr-btn-row { flex-direction: column; }
          .umr-btn-primary, .umr-btn-ghost { width: 100%; }
          .umr-form-head { flex-direction: column; align-items: flex-start; gap: 10px; }
          .umr-stats { gap: 10px; }
        }

        @media (max-width: 576px) {
          .umr-stat { padding: 16px 10px; border-radius: 14px; }
          .umr-stat-icon { width: 38px; height: 38px; font-size: 1rem; border-radius: 11px; margin-bottom: 10px; }
          .umr-stat-val { font-size: 1.3rem; }
          .umr-stat-lbl { font-size: 0.58rem; }
          .umr-glass { border-radius: 18px; }
          .umr-glass-body { padding: 18px; }
          .umr-input, .umr-select, .umr-textarea { font-size: 0.88rem; padding-top: 12px; padding-bottom: 12px; border-radius: 11px; }
          .umr-check { padding: 12px 14px; border-radius: 11px; }
          .umr-btn-primary, .umr-btn-ghost { border-radius: 12px; min-height: 50px; font-size: 0.9rem; }
        }

        @media (max-width: 400px) {
          .umr-stats { grid-template-columns: repeat(2, 1fr); gap: 8px; }
          .umr-stat { padding: 14px 8px; }
          .umr-stat-val { font-size: 1.1rem; }
        }

        /* iOS specific */
        @supports (-webkit-touch-callout: none) {
          .umr-app { min-height: 100dvh; }
          .umr-input, .umr-select, .umr-search, .umr-textarea { font-size: 16px; }
        }

        /* Touch devices */
        @media (hover: none) and (pointer: coarse) {
          .umr-stat:hover { transform: none; box-shadow: none; }
          .umr-input:hover:not(:focus) { border-color: rgba(255,255,255,0.065); background: rgba(14,14,28,0.6); }
        }
      `}</style>

      <div className="umr-root">
        <div className="umr-app">
          <div className="umr-content">

            {/* Header */}
            <div className="umr-header">
              <div className="umr-badge">
                <span>👤</span>
                Sisitemu y'Abantu
              </div>
              <h1 className="umr-title">Kongeramo Umuntu mu Rugo</h1>
              <p className="umr-subtitle">Huza umuntu n'urugo rwe mu buryo bworoshye</p>
            </div>

            {/* Stats */}
            <div className="umr-stats">
              <div className="umr-stat violet">
                <div className="umr-stat-icon" style={{ background: 'rgba(139,92,246,0.12)', color: '#a78bfa' }}>👥</div>
                <div className="umr-stat-val">{records.length}</div>
                <div className="umr-stat-lbl">Imihuza yose</div>
              </div>
              <div className="umr-stat blue">
                <div className="umr-stat-icon" style={{ background: 'rgba(59,130,246,0.12)', color: '#60a5fa' }}>🏠</div>
                <div className="umr-stat-val">{new Set(records.map(r => r.urugo_id)).size}</div>
                <div className="umr-stat-lbl">Ingo zitandukanye</div>
              </div>
              <div className="umr-stat emerald">
                <div className="umr-stat-icon" style={{ background: 'rgba(16,185,129,0.12)', color: '#34d399' }}>💼</div>
                <div className="umr-stat-val">{records.filter(r => r.afite_akazi_gahoraho).length}</div>
                <div className="umr-stat-lbl">Bafite akazi</div>
              </div>
              <div className="umr-stat amber">
                <div className="umr-stat-icon" style={{ background: 'rgba(245,158,11,0.12)', color: '#fbbf24' }}>🎓</div>
                <div className="umr-stat-val">{records.filter(r => r.urwego_amashuri && r.urwego_amashuri !== 'Ntacyo').length}</div>
                <div className="umr-stat-lbl">Bize amashuri</div>
              </div>
            </div>

            {/* Toggle */}
            <div className="umr-toggle-wrap">
              <div className="umr-toggle">
                <button className={`umr-toggle-btn ${activeView === 'form' ? 'active' : ''}`} onClick={() => setActiveView('form')}>
                  ✏️ Iyandikisha
                </button>
                <button className={`umr-toggle-btn ${activeView === 'records' ? 'active' : ''}`} onClick={() => setActiveView('records')}>
                  📋 Amakuru
                  <span className="umr-toggle-count">{records.length}</span>
                </button>
              </div>
            </div>

            {/* Alerts */}
            {success && (
              <div className="umr-alert umr-alert-ok">
                <div className="umr-alert-icon" style={{ background: 'rgba(34,197,94,0.12)' }}>✅</div>
                <div>
                  <div style={{ fontWeight: 700, marginBottom: 2 }}>Byagenze neza!</div>
                  <div style={{ opacity: 0.8, fontSize: '0.82rem' }}>{success}</div>
                </div>
                <button className="umr-alert-close" onClick={() => setSuccess(null)}>✕</button>
              </div>
            )}
            {error && (
              <div className="umr-alert umr-alert-err">
                <div className="umr-alert-icon" style={{ background: 'rgba(239,68,68,0.12)' }}>⚠️</div>
                <div>
                  <div style={{ fontWeight: 700, marginBottom: 2 }}>Hari ikibazo!</div>
                  <div style={{ opacity: 0.8, fontSize: '0.82rem' }}>{error}</div>
                </div>
                <button className="umr-alert-close" onClick={() => setError(null)}>✕</button>
              </div>
            )}

            {/* ═══ FORM ═══ */}
            {activeView === 'form' && (
              <div className="umr-glass" style={{ animation: 'scaleIn 0.45s ease', marginBottom: 32 }}>
                <div className="umr-glass-body">

                  <div className="umr-form-head">
                    <div className="umr-form-icon">👤</div>
                    <div>
                      <div className="umr-form-title">Fomu yo Kongeramo</div>
                      <div className="umr-form-desc">Uzuza amakuru yose ku muntu ushaka kongeramo mu rugo</div>
                    </div>
                  </div>

                  <form onSubmit={handleSubmit}>

                    {/* Section: Identification */}
                    <div className="umr-section">
                      <div className="umr-section-dot" style={{ background: 'rgba(99,102,241,0.1)', color: '#818cf8' }}>🔗</div>
                      <span className="umr-section-text">Ihuza ry'umuntu n'urugo</span>
                    </div>
                    <div className="umr-grid umr-grid-3" style={{ marginBottom: 28 }}>
                      <div className="umr-field">
                        <label className="umr-label">Umuntu ID <span className="umr-required">*</span></label>
                        <div className="umr-input-wrap">
                          <span className="umr-input-icon">🆔</span>
                          <input type="number" name="umuntu_id" value={formData.umuntu_id} onChange={handleChange}
                            className="umr-input" placeholder="Nimero y'umuntu" required />
                        </div>
                      </div>
                      <div className="umr-field">
                        <label className="umr-label">Urugo ID <span className="umr-required">*</span></label>
                        <div className="umr-input-wrap">
                          <span className="umr-input-icon">🏠</span>
                          <input type="number" name="urugo_id" value={formData.urugo_id} onChange={handleChange}
                            className="umr-input" placeholder="Nimero y'urugo" required />
                        </div>
                      </div>
                      <div className="umr-field">
                        <label className="umr-label">Umwanya mu rugo <span className="umr-required">*</span></label>
                        <div className="umr-input-wrap">
                          <span className="umr-input-icon">👪</span>
                          <select name="umwanya_mu_rugo" value={formData.umwanya_mu_rugo} onChange={handleChange}
                            className="umr-select" required>
                            <option value="Umukuru_w_urugo">Umukuru w'urugo</option>
                            <option value="Umugore">Umugore</option>
                            <option value="Umugabo">Umugabo</option>
                            <option value="Umwana">Umwana</option>
                            <option value="Umukurambere">Umukurambere</option>
                            <option value="Umuvandimwe">Umuvandimwe</option>
                            <option value="Undi">Undi</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* Section: Work & Education */}
                    <div className="umr-section">
                      <div className="umr-section-dot" style={{ background: 'rgba(16,185,129,0.1)', color: '#34d399' }}>💼</div>
                      <span className="umr-section-text">Umwuga n'Amashuri</span>
                    </div>
                    <div className="umr-grid umr-grid-2" style={{ marginBottom: 20 }}>
                      <div className="umr-field">
                        <label className="umr-label">Umwuga / Akazi</label>
                        <div className="umr-input-wrap">
                          <span className="umr-input-icon">🛠️</span>
                          <input type="text" name="umwuga_akazi" value={formData.umwuga_akazi} onChange={handleChange}
                            className="umr-input" placeholder="Urugero: Umuhinzi, Umwarimu..." />
                        </div>
                      </div>
                      <div className="umr-field">
                        <label className="umr-label">Urwego rw'Amashuri</label>
                        <div className="umr-input-wrap">
                          <span className="umr-input-icon">🎓</span>
                          <select name="urwego_amashuri" value={formData.urwego_amashuri} onChange={handleChange} className="umr-select">
                            <option value="Ntacyo">Ntacyo</option>
                            <option value="Abanza">Abanza</option>
                            <option value="Ayisumbuye">Ayisumbuye</option>
                            <option value="Kaminuza">Kaminuza</option>
                            <option value="TvET">TVET</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="umr-grid umr-grid-2" style={{ marginBottom: 28 }}>
                      <label className="umr-check">
                        <input type="checkbox" name="afite_umushinga" checked={formData.afite_umushinga} onChange={handleChange} />
                        <div className="umr-check-box">✓</div>
                        <span className="umr-check-text">Afite umushinga w'ubucuruzi</span>
                      </label>
                      <label className="umr-check">
                        <input type="checkbox" name="afite_akazi_gahoraho" checked={formData.afite_akazi_gahoraho} onChange={handleChange} />
                        <div className="umr-check-box">✓</div>
                        <span className="umr-check-text">Afite akazi gahoraho</span>
                      </label>
                    </div>

                    {/* Section: Children */}
                    <div className="umr-section">
                      <div className="umr-section-dot" style={{ background: 'rgba(244,63,94,0.1)', color: '#fb7185' }}>📚</div>
                      <span className="umr-section-text">Amakuru y'abana</span>
                    </div>
                    <div className="umr-grid umr-grid-full" style={{ marginBottom: 16 }}>
                      <div className="umr-field">
                        <label className="umr-label">Abana bari ku ishuri (amazina + ishuri)</label>
                        <textarea name="abana_bari_ku_ishuri" value={formData.abana_bari_ku_ishuri} onChange={handleChange}
                          className="umr-textarea" placeholder="Urugero: Kalisa Jean — GS Kigali, Uwimana Marie — EP Remera..." rows="3" />
                      </div>
                    </div>
                    <div className="umr-grid umr-grid-full" style={{ marginBottom: 28 }}>
                      <div className="umr-field">
                        <label className="umr-label">Abana batari ku ishuri (amazina + impamvu)</label>
                        <textarea name="abana_batari_ku_ishuri" value={formData.abana_batari_ku_ishuri} onChange={handleChange}
                          className="umr-textarea" placeholder="Urugero: Habimana Paul — nta mafaranga, Mukiza Anne — ubumuga..." rows="3" />
                      </div>
                    </div>

                    {/* Section: Dates */}
                    <div className="umr-section">
                      <div className="umr-section-dot" style={{ background: 'rgba(245,158,11,0.1)', color: '#fbbf24' }}>📅</div>
                      <span className="umr-section-text">Amatariki</span>
                    </div>
                    <div className="umr-grid umr-grid-2" style={{ marginBottom: 8 }}>
                      <div className="umr-field">
                        <label className="umr-label">Yatangiye umwanya</label>
                        <div className="umr-input-wrap">
                          <span className="umr-input-icon">📅</span>
                          <input type="date" name="yatangiye_umwanya" value={formData.yatangiye_umwanya} onChange={handleChange}
                            className="umr-input" />
                        </div>
                      </div>
                      <div className="umr-field">
                        <label className="umr-label">Yararaye umwanya</label>
                        <div className="umr-input-wrap">
                          <span className="umr-input-icon">📅</span>
                          <input type="date" name="yararaye_umwanya" value={formData.yararaye_umwanya} onChange={handleChange}
                            className="umr-input" />
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="umr-btn-row">
                      <button type="submit" className="umr-btn-primary" disabled={submitting}>
                        <span>
                          {submitting ? (
                            <>
                              <div className="spinner-border spinner-border-sm" style={{
                                width: '18px', height: '18px',
                                borderWidth: '2px',
                                borderColor: 'rgba(255,255,255,0.25)',
                                borderTopColor: '#fff'
                              }}></div>
                              Tegereza...
                            </>
                          ) : (
                            <>
                              ✨ Ongera Umuntu mu Rugo
                            </>
                          )}
                        </span>
                      </button>
                      <button type="button" className="umr-btn-ghost" onClick={() => setFormData(initialForm)}>
                        🔄 Siba byose
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {/* ═══ RECORDS ═══ */}
            {activeView === 'records' && (
              <div className="umr-glass" style={{ animation: 'scaleIn 0.45s ease' }}>
                <div className="umr-glass-body">

                  {/* Records Header */}
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '14px',
                    marginBottom: '24px',
                    paddingBottom: '20px',
                    borderBottom: '1px solid rgba(255,255,255,0.045)'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <div style={{
                        width: 44, height: 44, borderRadius: 13,
                        background: 'linear-gradient(135deg, rgba(139,92,246,0.15), rgba(99,102,241,0.15))',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: '1.1rem', flexShrink: 0
                      }}>📋</div>
                      <div>
                        <div style={{ fontWeight: 800, color: '#fff', fontSize: '1.15rem' }}>
                          Abantu mu ngo
                        </div>
                        <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: '0.8rem' }}>
                          {filteredRecords.length} mu {records.length} byose
                        </div>
                      </div>
                    </div>
                    <div className="umr-search-wrap">
                      <span className="umr-search-icon">🔍</span>
                      <input
                        type="search"
                        className="umr-search"
                        placeholder="Shakisha amazina, NIDA, urugo..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>

                  {loading ? (
                    <div className="umr-loader">
                      <span></span><span></span><span></span>
                    </div>
                  ) : filteredRecords.length === 0 ? (
                    <div className="umr-empty">
                      <div className="umr-empty-icon">👤</div>
                      <h5 style={{ color: 'rgba(255,255,255,0.45)', fontWeight: 700, marginBottom: 6 }}>
                        Nta makuru abonetse
                      </h5>
                      <p style={{ color: 'rgba(255,255,255,0.22)', fontSize: '0.88rem', maxWidth: 380, margin: '0 auto' }}>
                        {searchTerm ? 'Hindura amagambo mu gushakisha' : 'Tangira wongeremo umuntu mu rugo'}
                      </p>
                    </div>
                  ) : (
                    <>
                      {/* Desktop Table */}
                      <div className="umr-desktop-table">
                        <div className="umr-table-wrap">
                          <div className="umr-table-scroll">
                            <table className="umr-table">
                              <thead>
                                <tr>
                                  <th style={{ paddingLeft: 22 }}>#</th>
                                  <th>Umuntu</th>
                                  <th>NIDA</th>
                                  <th>Urugo</th>
                                  <th>Umwanya</th>
                                  <th>Akazi</th>
                                  <th>Amashuri</th>
                                  <th>Umushinga</th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredRecords.map((link, i) => {
                                  const roleBadge = getRoleBadge(link.umwanya_mu_rugo);
                                  const eduBadge = getEduBadge(link.urwego_amashuri);
                                  return (
                                    <tr key={link.id} style={{ animation: `slideRow 0.35s ease ${i * 0.04}s both` }}>
                                      <td style={{ paddingLeft: 22, color: 'rgba(255,255,255,0.25)', fontWeight: 600 }}>{i + 1}</td>
                                      <td style={{ fontWeight: 700, color: '#fff' }}>{link.umuntu_name || '-'}</td>
                                      <td>
                                        <span className="umr-tag" style={{
                                          background: 'rgba(99,102,241,0.1)',
                                          color: '#818cf8',
                                          borderColor: 'rgba(99,102,241,0.18)'
                                        }}>{link.nimero_nida || '—'}</span>
                                      </td>
                                      <td>
                                        <div style={{ fontWeight: 600, color: 'rgba(255,255,255,0.75)' }}>{link.nimero_urugo || '-'}</div>
                                        <div style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.3)', marginTop: 2 }}>{link.amazina_umukuru || ''}</div>
                                      </td>
                                      <td>
                                        <span className="umr-tag" style={{
                                          background: roleBadge.bg,
                                          color: roleBadge.color,
                                          borderColor: roleBadge.border
                                        }}>
                                          {(link.umwanya_mu_rugo || '').replace(/_/g, ' ')}
                                        </span>
                                      </td>
                                      <td style={{ color: link.umwuga_akazi ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.2)' }}>
                                        {link.umwuga_akazi || '—'}
                                      </td>
                                      <td>
                                        <span className="umr-tag" style={{
                                          background: eduBadge.bg,
                                          color: eduBadge.color,
                                          borderColor: 'transparent'
                                        }}>{link.urwego_amashuri || 'Ntacyo'}</span>
                                      </td>
                                      <td>
                                        {link.afite_umushinga ? (
                                          <span style={{
                                            display: 'inline-flex',
                                            width: 26, height: 26, borderRadius: 8,
                                            background: 'rgba(34,197,94,0.12)',
                                            alignItems: 'center', justifyContent: 'center',
                                            fontSize: '0.8rem'
                                          }}>✅</span>
                                        ) : (
                                          <span style={{ color: 'rgba(255,255,255,0.15)' }}>—</span>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      {/* Mobile Cards */}
                      <div>
                        {filteredRecords.map((link, i) => {
                          const roleBadge = getRoleBadge(link.umwanya_mu_rugo);
                          const eduBadge = getEduBadge(link.urwego_amashuri);
                          const isExpanded = expandedCard === link.id;
                          return (
                            <div
                              key={link.id}
                              className="umr-mobile-card"
                              style={{ animation: `fadeUp 0.35s ease ${i * 0.04}s both` }}
                              onClick={() => setExpandedCard(isExpanded ? null : link.id)}
                            >
                              <div className="umr-mc-head">
                                <div>
                                  <div className="umr-mc-name">{link.umuntu_name || '-'}</div>
                                  <span className="umr-tag" style={{
                                    background: roleBadge.bg,
                                    color: roleBadge.color,
                                    borderColor: roleBadge.border,
                                    fontSize: '0.7rem'
                                  }}>
                                    {(link.umwanya_mu_rugo || '').replace(/_/g, ' ')}
                                  </span>
                                </div>
                                <span className="umr-tag" style={{
                                  background: 'rgba(99,102,241,0.1)',
                                  color: '#818cf8',
                                  borderColor: 'rgba(99,102,241,0.18)'
                                }}>{link.nimero_nida || '—'}</span>
                              </div>
                              <div className="umr-mc-row">
                                <span className="umr-mc-lbl">Urugo</span>
                                <span className="umr-mc-val">{link.nimero_urugo || '—'}</span>
                              </div>
                              <div className="umr-mc-row">
                                <span className="umr-mc-lbl">Umukuru</span>
                                <span className="umr-mc-val">{link.amazina_umukuru || '—'}</span>
                              </div>
                              {isExpanded && (
                                <div style={{ animation: 'fadeUp 0.3s ease' }}>
                                  <div className="umr-mc-row">
                                    <span className="umr-mc-lbl">Akazi</span>
                                    <span className="umr-mc-val">{link.umwuga_akazi || '—'}</span>
                                  </div>
                                  <div className="umr-mc-row">
                                    <span className="umr-mc-lbl">Amashuri</span>
                                    <span className="umr-mc-val">
                                      <span className="umr-tag" style={{
                                        background: eduBadge.bg,
                                        color: eduBadge.color,
                                        borderColor: 'transparent',
                                        fontSize: '0.7rem'
                                      }}>{link.urwego_amashuri || 'Ntacyo'}</span>
                                    </span>
                                  </div>
                                  <div className="umr-mc-row">
                                    <span className="umr-mc-lbl">Umushinga</span>
                                    <span className="umr-mc-val">{link.afite_umushinga ? '✅ Yego' : '—'}</span>
                                  </div>
                                  <div className="umr-mc-row">
                                    <span className="umr-mc-lbl">Akazi gahoraho</span>
                                    <span className="umr-mc-val">{link.afite_akazi_gahoraho ? '✅ Yego' : '—'}</span>
                                  </div>
                                </div>
                              )}
                              <div style={{ textAlign: 'center', marginTop: 8, color: 'rgba(255,255,255,0.12)', fontSize: '0.75rem' }}>
                                {isExpanded ? '▲ Funga' : '▼ Reba byinshi'}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}

            {/* Footer */}
            <div style={{
              textAlign: 'center',
              marginTop: 40,
              paddingBottom: 16,
              animation: 'fadeUp 1s ease'
            }}>
              <p style={{ color: 'rgba(255,255,255,0.12)', fontSize: '0.75rem', fontWeight: 500 }}>
                🔒 Amakuru yose arindwa kandi akoreshwa ku buryo bw'amategeko
              </p>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default UmuntuMuRugo;